import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // 
import SubtleBackground from "../components/SubtleBackground";
import logo from "../assets/3ALOGO.png";
const API_URL = process.env.REACT_APP_API_URL;
const Login = ({ setAuth, setRole }) => {
  const navigate = useNavigate(); // ✅ ADDED

  const [form, setForm] = useState({
    username: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };
const [statusMsg, setStatusMsg] = useState("");

const handleLogin = async (e) => {
  e.preventDefault();

  if (!form.username || !form.password) {
    setError("Please enter username and password");
    return;
  }

  setError("");
  setStatusMsg("Connecting to server...");
  setLoading(true);

  try {
    const res = await axios.post(
      `${API_URL}/api/login`,
      { username: form.username, password: form.password },
      { timeout: 20000 } // give it enough time for the DB round trip
    );

    const access_token = res.data.access_token;
    if (!access_token) throw new Error("Token not received");

    localStorage.setItem("token", access_token);
    window.location.href = "/";
  } catch (err) {
    console.log("LOGIN ERROR:", err);

    if (!err.response) {
      // No response = network error, timeout, CORS issue, DNS issue, server down
      // NOT a wrong password — don't say "invalid credentials"
      if (err.code === "ECONNABORTED") {
        setError("Server is taking too long to respond. Please try again.");
      } else {
        setError("Unable to reach the server. Check your connection and try again.");
      }
    } else if ([502, 503, 504].includes(err.response.status)) {
      setError("Server is temporarily unavailable. Please try again shortly.");
    } else if (err.response.status === 401 || err.response.status === 400) {
      // This is a REAL response from the server saying credentials are wrong
      setError(err.response.data?.detail || "Invalid credentials");
    } else {
      setError(err.response.data?.detail || "Something went wrong. Please try again.");
    }
  } finally {
    setLoading(false);
    setStatusMsg("");
  }
};
//   const handleLogin = async (e) => {
//     e.preventDefault();

//     if (!form.username || !form.password) {
//       setError("Please enter username and password");
//       return;
//     }

//     setError("");
//     setLoading(true);

//     try {
//    const res = await axios.post(`${API_URL}/api/login`, {
//   username: form.username,
//   password: form.password,
// });

//       console.log("LOGIN RESPONSE:", res.data); // ✅ DEBUG

//       const access_token = res.data.access_token;

//       if (!access_token) {
//         throw new Error("Token not received");
//       }

//       // ✅ STORE TOKEN
//      localStorage.setItem("token", access_token);

// // 🔥 FORCE FULL RELOAD (IMPORTANT)
// window.location.href = "/";
//       // ✅ REDIRECT AFTER LOGIN (IMPORTANT FIX)
//       navigate("/");

//     } catch (err) {
//       console.log("LOGIN ERROR:", err.response?.data); // ✅ DEBUG
//       setError(err.response?.data?.detail || "Invalid credentials");
//     } finally {
//       setLoading(false);
//     }
//   };

  return (
  <div className="min-h-screen flex items-center justify-center relative overflow-hidden bg-[#f5f7fb]">

    {/* SUBTLE BACKGROUND */}
    <SubtleBackground />

    {/* LOGIN CARD */}
<div className="relative z-10 w-full max-w-[320px]">

  <div className="bg-white/75 backdrop-blur-xl border border-gray-200 shadow-lg rounded-2xl px-6 py-6">

    {/* LOGO */}
    <div className="flex flex-col items-center mb-5">

   <div className="flex items-center justify-center">
  <img
    src={logo}
    alt="Logo"
    className="w-20 h-20 object-contain"
  />
</div>

      <h1 className="text-lg font-semibold text-gray-800 mt-3">
        Welcome Back
      </h1>

      <p className="text-xs text-gray-500 mt-1">
        Login to continue
      </p>
    </div>

    {/* ERROR */}
    {/* {error && (
      <div className="mb-3 text-xs text-red-600 bg-red-50 border border-red-200 rounded-lg py-2 px-3 text-center">
        {error}
      </div>
    )} */}
    {/* STATUS / LOADING MESSAGE */}
    {statusMsg && (
      <div className="mb-3 text-xs text-blue-600 bg-blue-50 border border-blue-200 rounded-lg py-2 px-3 text-center">
        {statusMsg}
      </div>
    )}

    {/* ERROR */}
    {error && (
      <div className="mb-3 text-xs text-red-600 bg-red-50 border border-red-200 rounded-lg py-2 px-3 text-center">
        {error}
      </div>
    )}

    {/* FORM */}
    <form onSubmit={handleLogin} className="space-y-3">

      {/* USERNAME */}
      <div>
        <input
          type="text"
          name="username"
          placeholder="Username"
          value={form.username}
          onChange={handleChange}
          disabled={loading}
          className="w-full h-10 px-3 rounded-lg border border-gray-200 bg-white text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 transition"
        />
      </div>

      {/* PASSWORD */}
      <div className="relative">

        <input
          type={showPassword ? "text" : "password"}
          name="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          disabled={loading}
          className="w-full h-10 px-3 rounded-lg border border-gray-200 bg-white text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 transition pr-14"
        />

        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-[11px] font-medium text-blue-600"
        >
          {showPassword ? "Hide" : "Show"}
        </button>

      </div>

      {/* LOGIN BUTTON */}
      <button
        type="submit"
        disabled={loading}
        className={`w-full h-10 rounded-lg text-sm font-medium text-white transition ${
          loading
            ? "bg-blue-400 cursor-not-allowed"
            : "bg-blue-600 hover:bg-blue-700"
        }`}
      >
        {loading ? "Signing..." : "Login"}
      </button>

    </form>

    {/* FOOTER */}
    <div className="mt-5 text-center">
      <p className="text-[10px] text-gray-400">
        Developed by{" "}
        <span className="font-medium text-gray-600">
          A K ENTERPRISES
        </span>
      </p>
    </div>

  

</div>
    </div>
  </div>
);
};

export default Login;